<script setup lang="ts">
const items = [
  {
    title: 'Ongkos Kirim Otomatis Multi-Kurir',
    icon: 'material-symbols:person-search',
    desc: 'Tarif pengiriman dari berbagai ekspedisi tampil otomatis di checkout WooCommerce, menghitung biaya kirim berdasarkan berat, jarak, dan layanan yang dipilih.'
  },
  {
    title: 'Cek Resi Plugin Real-Time',
    icon: 'material-symbols:nearby-error',
    desc: 'Berikan kenyamanan ekstra kepada pelanggan. Mereka cukup memasukkan nomor resi di halaman tracking toko untuk melihat status pengiriman secara real-time.'
  },
  {
    title: 'Integrasi Mudah Tanpa Coding',
    icon: 'material-symbols:integration-instructions-outline',
    desc: 'Hanya perlu beberapa langkah: install plugin, hubungkan API Key, atur kurir dan layanan. Plugin langsung aktif tanpa perlu kemampuan teknis khusus.'
  },
  {
    title: 'Dukungan Multi-Ekspedisi & COD Cepat Rilis',
    icon: 'material-symbols:widgets-outline',
    desc: 'Nikmati pengiriman dengan berbagai layanan ekspedisi nasional. Dana COD bisa cair cepat tanpa pending.'
  }
]
</script>

<template>
  <UiSectionWrapper
    image-class="order-first lg:order-first"
    title="Fitur Plugin WooCommerce KiriminAja"
    hero-image="/images/plugin/woocommerce/asset-1.webp"
    :items="items"
    item-subtitle-key="desc"
    class="py-12"
    :with-action="false"
  />
</template>
